import { useBinanceWsStore } from "@/providers/binance-ws-provider";
import { Asset } from "@/services/assets/schema";
import React from "react";
import { useShallow } from "zustand/shallow";
import { AssetLatestPrices } from "./queries/asset/use-asset-latest-prices";

interface LivePricesOptions {
  enabled: boolean;
}

const defaultOptions: LivePricesOptions = {
  enabled: true,
};

export function useLivePrices(
  assets: Pick<Asset, "symbol">[],
  options = defaultOptions,
) {
  const binanceLivePrices = useBinanceWsStore(
    useShallow((state) => state.binanceLivePrices),
  );
  const assetLatestPricesQuery = AssetLatestPrices.useQuery({
    staleTime: 0,
    gcTime: 0,
  });

  React.useEffect(() => {
    if (!assets) return;
    if (!options.enabled) return;

    const binanceWsStore = useBinanceWsStore.getState();
    const symbols = assets.map((asset) => asset.symbol);
    binanceWsStore.addSymbol(symbols);

    return () => {
      binanceWsStore.removeSymbol(symbols);
    };
  }, [assets, options.enabled]);

  return {
    coingeckoLivePrices: assetLatestPricesQuery.data,
    binanceLivePrices,
  };
}
